import React, { useContext } from 'react';
import proyectoContext from '../../context/proyectos/proyectoContext';
import tareaContext from '../../context/tareas/tareaContext';
import barraprincipalContext from '../../context/barraprincipal/barraprincipalContext';

const Proyecto = ({proyecto}) => {

    // Obtener el state del proyecto actual
    const proyectosContext = useContext(proyectoContext);
    const { proyectos, verdetalles, obtenerUltimosCambios, proyectoActual, verDetalles, proyectoActivo, obtenerAlturaContenedor } = proyectosContext;
    
    // Obtener la funcion del context de tarea
    const tareasContext = useContext(tareaContext);
    const { vertarea, obtenerTareas, limpiarTarea, verTarea, esconderFormulario, limpiarDescripcion, formularioDescripcion } = tareasContext; 

    // Extraer funciones del context
    const barrapplContext = useContext(barraprincipalContext);
    const { vistamenu, vistaMenu, verCuentas } = barrapplContext;

    // Funcion para agregar el proyecto actual
    const seleccionarProyecto = id => {
        const btnProyecto = document.getElementById(id);
        const btnTareas = document.getElementById('btn-tareas');
        const btnDetalle = document.getElementById('btn-detalles');
        const clase = btnProyecto.classList[2];
        
        // Si cuando seleccione un proyecto y no hay ninguno activo
        btnProyecto.classList.add('active');
        proyectoActivo(true);

        // Si selecciona otro proyecto
        proyectos.forEach(proyecto => {
            if(id !== proyecto._id){
                const btnProyecto = document.getElementById(proyecto._id);
                btnProyecto.classList.remove('active');
                verDetalles(false);
                limpiarTarea();
                limpiarDescripcion();
                formularioDescripcion(false);
            }
        });

        // Si selecciona otro proyecto y estaba en detalles, que vuelva a la vista predeterminada "tareas"
        if(btnDetalle) {
            btnTareas.classList.add('active');
            btnDetalle.classList.remove('active');
        }
        if(verdetalles){
            esconderFormulario();
        }

        // Si deseleccionan el proyecto activo
        if(clase === 'active'){
            btnProyecto.classList.remove('active');
            proyectoActivo(false);
            verDetalles(false);
            limpiarTarea();
            formularioDescripcion(false);
        }

        // Si está en vertarea
        if(vertarea){
            verTarea(false);
        }

        // Si está en cuentas
        if(vistamenu) {
            const btnAdminCuentas = document.getElementById("btn-admin-cuentas");
            const btnVerPerfil = document.getElementById("btn-ver-perfil");
            
            btnAdminCuentas.classList.remove('active');
            btnAdminCuentas.classList.add('no-active');
            btnVerPerfil.classList.remove('active');
            btnVerPerfil.classList.add('no-active');

            vistaMenu('');
            verCuentas(false);
        }

        proyectoActual(id); // Fijar un proyecto actual
        obtenerTareas(id); // Filtrar las tareas
        obtenerUltimosCambios(id); // Filtra los ultimos cambios
        obtenerAlturaContenedor(window.innerHeight - 56 - 247);
    }

    return ( 
        <li>
            <button
                type="button"
                id={proyecto._id}
                className="btn btn-proyecto"
                onClick={ () =>  seleccionarProyecto(proyecto._id)}
            >{proyecto.nombre}</button>
        </li>
    );
}

export default Proyecto;